export const PATH_WHITELIST = [
    'base.customer.domain.dashboard',
    'base.customer.domain.qa',
    'base.customer.domain.pages',
    'base.customer.domain.policy',
    'base.customer.domain.accessibility',
    'base.customer.domain.seo',
    'base.customer.domain.uptimes',
    'base.customer.domain.page-fix',
    'base.customer.domain.data-privacy',
    'base.customer.domain.page-performance',
    'base.customer.domain.statistics',
    'base.customer.domain.inventory',
    'base.customer.domain.changesHistory',
] as const;
